'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { closeCurrentModal } from '@kcd/app-interface/dist/web2app';

import { isLoadedInAppHavingMarketTab } from '~/utils/mobileApp';

/**
 * @description 홈으로 이동하는 함수 (app-router 사용 시에만 사용)
 * 인앱 마켓탭을 가지고 있는 앱이라면 home으로 갈때 closeCurrentModal을 부르고,
 * 그렇지 않으면 fallback으로 router[method]('/')를 호출
 */
export const useGoHome = (method: 'replace' | 'push' = 'push') => {
  const router = useRouter();

  return useCallback(() => {
    if (isLoadedInAppHavingMarketTab()) {
      closeCurrentModal();
      return;
    }

    void router[method]('/');
  }, [router, method]);
};
